var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`${_vm.node.data.object.type}-widget`,{tag:"component",class:{
    disabled: !_vm.node.data.has_access && _vm.isOverridePage,
    'default-cursor': !this.isOverridePage,
  },attrs:{"widget":_vm.node.data},on:{"show-enlarged":_vm.showEnlarged},nativeOn:{"click":function($event){return _vm.selectWidgetFromPlayer.apply(null, arguments)}}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }